import React from 'react';
import { DateTime } from 'luxon';
import Complete from './status/Complete';
import Incomplete from './status/Incomplete';
import NotStarted from './status/NotStarted';
import useDialogLauncher from '../../../dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import usePageRouter from '../../../dialogs-routable/_hooks/usePageRouter';
import Loader from '../../../components/Loader';
import RightMediaSection from '../_common/RightMediaSection';

export default function StatusMediaSection(props) {
  const { evaluation, showViewLink = true, showEditLink = true } = props;

  const { history } = usePageRouter();

  const user = useConnect('user.byId', {
    id: evaluation.data.userId
  });

  const event = useConnect('event.byId', {
    id: evaluation.data.eventId
  });

  const launch = useDialogLauncher();

  function onClickView() {
    if (user.id === event.data.creatorId) {
      launch(DialogManager.EvaluationEventEducator.Config(evaluation.id));
    } else {
      launch(DialogManager.EvaluationEventPartner.Config(evaluation.id));
    }
  }

  function onClickEdit() {
    if (user.id === event.data.creatorId) {
      history.push(`/evaluation-event-educator/${evaluation.id}`);
    } else {
      history.push(`/evaluation-event-partner/${evaluation.id}`);
    }
  }

  const diff = DateTime.fromISO(evaluation.data.updatedAt).toMillis() - DateTime.fromISO(evaluation.data.createdAt).toMillis();

  if (event.state === PayloadStates.FETCHING) {
    // return (
    //   <div className="w-24">
    //     <Loader />
    //   </div>
    // );
    return (
      <RightMediaSection
        title="..."
        subtitle="..."
      />
    )
  }

  // return (
  //   <NotStarted
  //     evaluation={evaluation}
  //     onClickView={showViewLink && onClickView}
  //     onClickEdit={showEditLink && onClickEdit}
  //   />
  // );

  if (evaluation.data.completed) {
    return (
      <Complete
        evaluation={evaluation}
        onClickView={showViewLink && onClickView}
        onClickEdit={showEditLink && onClickEdit}
      />
    );
  }

  if (diff > 100) {
    return (
      <Incomplete
        evaluation={evaluation}
        onClickView={showViewLink && onClickView}
        onClickEdit={showEditLink && onClickEdit}
      />
    );
  }

  return (
    <NotStarted
      evaluation={evaluation}
      onClickView={showViewLink && onClickView}
      onClickEdit={showEditLink && onClickEdit}
    />
  );
};
